/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';

import { Row, Col, Button, Table } from "react-bootstrap";

import AccountContainer from "./AccountContainer";
import { formatDisplayDate } from '../../engine/date-helpers';
import {calcLastModified} from "../../components/helpers";



function AccountCalendar(props) {
  const { search } = useLocation(); // optional ?index=xxx

  let index = -1;
  if (search.length > 0) {
    let pos = search.indexOf("=");
    if (pos !== -1) {
      index = parseInt(search.substring(pos + 1))
    }
  }


  return (
    <AccountContainer>
      <AccountCalendarPane monthIndex={index} />
    </AccountContainer>
  );
}


//---------------------------------------------------------------------------------------
//
//---------------------------------------------------------------------------------------

function AccountCalendarPane(props) {
  const timespan = props.results.simResults.timeSpan;
  const t = timespan;
  const max_idx = t.timeline.length - 1;
  const start_index = props.monthIndex === -1 ? t.curMonth.index : props.monthIndex;

  const [curMonthIdx, setCurMonthIdx] = useState(start_index);


  function calcRange(index) {
    let prevMonth = index === 0 ? 0 : index - 1;
    let prevYear = index - 12 < 0 ? 0 : index - 12;
    let nextMonth = index === max_idx ? max_idx : index + 1;
    let nextYear = index + 12 > max_idx ? max_idx : index + 12;

    let range = {
      month: t.timeline[index],
      curMonth: t.timeline[index].monthLabel,
      curYear: t.timeline[index].year,
      prevMonth: t.timeline[prevMonth].monthLabel,
      prevYear: t.timeline[prevYear].year,
      nextMonth: t.timeline[nextMonth].monthLabel,
      nextYear: t.timeline[nextYear].year,
    }

    return range
  }

  function onPrevMonth(event) {
    event.preventDefault();

    if (curMonthIdx === 0) {
      return;
    }

    setCurMonthIdx(curMonthIdx - 1);
  }

  function onPrevYear(event) {
    event.preventDefault();

    if (curMonthIdx - 12 < 0) {
      return;
    }

    setCurMonthIdx(curMonthIdx - 12);
  }

  function onNextMonth(event) {
    event.preventDefault();

    if (curMonthIdx === max_idx) {
      return;
    }

    setCurMonthIdx(curMonthIdx + 1);
  }

  function onNextYear(event) {
    event.preventDefault();

    if (curMonthIdx + 12 > max_idx) {
      return;
    }

    setCurMonthIdx(curMonthIdx + 12);
  }


  let range = calcRange(curMonthIdx);

  let details = range.month.monthSummaries[props.simAcct.index];

  let td_style = {

  }


  return (
    <Row>
      <Col sm={{ span: 6, offset: 3 }}>
        <Row>
          <Col>
            <span>{props.simAcct.baseDesc}</span><span>{calcLastModified(props.simAcct.lastUpdate)}</span>
            <table>
              <tbody>
                <tr>
                  <td rowSpan={2}>45</td>
                  <td>Start balance</td><td style={td_style}>{details.calendarStartBal.toFixed(2)}</td>
                  <td>Total credits</td><td style={td_style}>{details.getTotalCredits(true).toFixed(2)}</td>
                  <td rowSpan={2}>{details.monthDelinquent.toFixed(2)}</td>
                </tr>
                <tr>
                  <td>End balance</td><td style={td_style}>{details.calendarEndBal.toFixed(2)}</td>
                  <td>Total debits</td><td style={td_style}>{details.getTotalDebits(true).toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
        <Row>

          <Col><Button size="xs" onClick={onPrevYear}>{range.prevYear}</Button></Col>
          <Col><Button size="xs" onClick={onPrevMonth}>{range.prevMonth}</Button></Col>

          <Col xs={2}><span>{range.curMonth}</span>-<span>{range.curYear}</span></Col>

          <Col><Button size="xs" onClick={onNextMonth}>{range.nextMonth}</Button></Col>
          <Col><Button size="xs" onClick={onNextYear}>{range.nextYear}</Button></Col>

        </Row>

        <Row>
          <Col>
            <Details month={range.month} acct={props.simAcct} details={details} />
          </Col>
        </Row>

      </Col>
    </Row>
  );
}


export default AccountCalendar;







//-----------------------------------------------------------------------------
//
//-----------------------------------------------------------------------------


const Details = (props) => {
  var raw_trans = props.month.monthTrans.filter(t => t.account.baseID === props.acct.baseID);
  var month_header = props.details;


  var running_bal = month_header.calendarStartBal;
  var remaining_debt = month_header.getTotalDebits(true);


  function process_month(trans) {
    if (trans.length === 0) {
      return [];
    }

    let final = [];

    let tot_debit = 0;
    let tot_credit = 0;



    for (let i = 0; i < trans.length; i++) {
      const t = trans[i];


      running_bal += t.op * t.amount;
      if (t.op < 0) {
        tot_debit += t.amount;
        remaining_debt -= t.amount;
      } else {
        tot_credit += t.amount;
      }

      let row = {
        group: 0,

        day: t.dateNum - t.month * 100,
        desc: t.tranDesc,

        debit: t.op < 0 ? t.amount.toFixed(2) : '',
        credit: t.op > 0 ? t.amount.toFixed(2) : '',

        balance: running_bal.toFixed(2),
        remainingDebt: remaining_debt.toFixed(2),

        delinquentAmount: t.delinquentAmount,
      }

      final.push(row);
    }


    return final;
  }


  var td_style = {
    padding: "4px 6px"
  }


  function detailRow(t, i) {
    return (
      <tr key={i}>
        <td style={td_style}>{t.day}</td>
        <td style={td_style}>{t.desc}</td>
        <td style={td_style}>{t.debit}</td>
        <td style={td_style}>{t.credit}</td>
        <td style={td_style}>{t.balance}</td>
        <td style={td_style}>{t.remainingDebt}</td>

        <td style={td_style}>{t.delinquentAmount}</td>
      </tr>
    );
  }


  const trans = process_month(raw_trans);


  return (
    <Table>
      <thead>
        <tr>
          <th>Day</th>
          <th>Desc</th>
          <th>Debits</th>
          <th>Credits</th>
          <th>Balance</th>
          <th>Still Owing</th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        {trans.map((t, i) => detailRow(t, i))}
      </tbody>
    </Table>
  );
}

